import registerInvigilatorMenuController from './InvigilatorMenuController';
import registerPauseController from './PauseController';
import registerAdminEventTypeDirective from './AdminEventTypeDirective';

export default function registerInvigilatorMenu(angular) {
    const assessmentFrontendControllers = angular.module('assessmentFrontendControllers');
    const assessmentFrontendDirectives = angular.module('assessmentFrontendDirectives');

    registerInvigilatorMenuController(assessmentFrontendControllers);
    registerPauseController(assessmentFrontendControllers);
    registerAdminEventTypeDirective(assessmentFrontendDirectives);
}
